import styled from "styled-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  MDBCard,
  MDBCardHeader,
  MDBCardTitle,
  MDBCardBody,
} from "mdb-react-ui-kit";
import { CardElement } from "@stripe/react-stripe-js";
import { useHandleSubmitPayment } from "../lib/usePayment";
import { Button, Row } from "../App.styles";
import { Alert, Refresher, Spinner } from "../common";
import { Input } from "../common/Input";
import { FormSelect } from "../common/FormSelect";
import { useGameQuery } from "../settings/Settings.state";
import { useDonationPayMutation } from "./Donation.state";

const stripeStyles = {
  style: {
    base: {
      fontSize: "16px",
    },
  },
};

const CardRow = styled(Row)`
  margin: 1rem 0 2rem;
`;

const Donation = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState("20");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const gameQuery = useGameQuery();
  const mutation = useDonationPayMutation();

  const handleSubmit = useHandleSubmitPayment({
    onBefore: () => {
      setSuccess(false);
      setError(false);
    },
    onError: (error) => {
      setError(error?.message);
      console.error("[Donation] Payment Error: ", error);
    }, 
    onSuccess: () => {
      setSuccess(true);
    }, 
    mutation, 
    params: {
      email,
      cost: amount,
    }
  })

  return (
    <>
      {error && <Alert color="error">{error}</Alert>}
      <Row>
        <MDBCard>
          <MDBCardHeader>
            <MDBCardTitle>
              {success
                ? t("Thank you for your donation!")
                : `Donate to ${gameQuery[0].name}`}
            </MDBCardTitle>
          </MDBCardHeader>
          <MDBCardBody>
            <form onSubmit={handleSubmit}>
              <Row>
                <Input label={t("Enter Email:")} value={email} setValue={setEmail} />
              </Row>
              <Row>
                <FormSelect
                  label={t("Your Contribution:")}
                  value={amount}
                  setValue={setAmount}
                  style={{ border: "1px solid #bdbdbd", marginTop: "15px" }}
                >
                  <option value="10">
                    $10.00 { t(`(Suggested - thank you for playing)`) }
                  </option>
                  <option value="20" selected="selected">
                    $20.00 { t(`(You are too kind)`) }
                  </option>
                  <option value="50">
                    $50.00 { t(`(You had an epic journey I see!)`) }
                  </option>
                  <option value="100">
                    $100.00 { t(`(We’re rechecking your highlight reel!)`) }
                  </option>
                </FormSelect>
              </Row>
              <CardRow
                style={{
                  borderBottom: "1px solid #bdbdbd",
                  paddingBottom: "10px",
                  marginTop: "25px",
                }}
              >
                <CardElement options={stripeStyles} />
              </CardRow>
              <Row>
                {success ? (
                  <Button
                    color="success"
                    style={{ width: "200px", marginLeft: "10px" }}
                  >
                    <span dangerouslySetInnerHTML={{__html: t(`Thank you.`)}} />
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    type="submit"
                    style={{ width: "200px", marginLeft: "10px" }}
                  >
                    <span dangerouslySetInnerHTML={{__html: t(`Pay Now`)}} /> {mutation?.isPaying && <Spinner size="0.875rem" />}
                  </Button>
                )}
              </Row>
            </form>
          </MDBCardBody>
        </MDBCard>
      </Row>
      <Refresher />
    </>
  );
};

export default Donation;
